import type { ProgramTypeApi } from "../../api/ProgramTypeApi";
import type { DeleteProgramTypeStaff } from "../../generated/dto/DeleteProgramTypeStaff";
import type { ProgramTypeSearchParams } from "../../generated/dto/ProgramTypeSearchParams";
import type { ProgramTypeStaff } from "../../generated/dto/ProgramTypeStaff";
import type { ProgramTypeStaffSearchResult } from "../../generated/dto/ProgramTypeStaffSearchResult";
import type { UpdateProgramType } from "../../generated/dto/UpdateProgramType";
import type { PaginationResult } from "../../generated/dto/PaginationResult";

export class ProgramTypeFrontendService {
  constructor(private readonly api: ProgramTypeApi) {}
  private readonly programTypeStaffCache: Map<number, ProgramTypeStaff> = new Map();
  async getProgramTypeStaff(id: number): Promise<ProgramTypeStaff> {
    const __cached = this.programTypeStaffCache.get(id);
    if (__cached !== undefined) {
      return __cached
    }
    const __value = await this.api.getProgramTypeStaff(id);
    this.programTypeStaffCache.set(id, __value);
    return __value
  }
  async getAllProgramTypeStaffs(): Promise<Array<ProgramTypeStaff>> {
    return this.api.getAllProgramTypeStaffs()
  }
  async updateProgramTypeStaff(source: UpdateProgramType): Promise<ProgramTypeStaff> {
    const __result = await this.api.updateProgramTypeStaff(source);
    this.programTypeStaffCache.clear();
    return __result
  }
  async deleteProgramTypeStaff(source: DeleteProgramTypeStaff): Promise<void> {
    const __result = await this.api.deleteProgramTypeStaff(source);
    this.programTypeStaffCache.clear();
    return __result
  }
  async searchProgramTypeStaff(params: ProgramTypeSearchParams, page: number, perPage: number): Promise<PaginationResult<ProgramTypeStaffSearchResult>> {
    return this.api.searchProgramTypeStaff(params, page, perPage)
  }
  async searchProgramTypeStaffFull(params: ProgramTypeSearchParams, page: number, perPage: number): Promise<PaginationResult<ProgramTypeStaff>> {
    return this.api.searchProgramTypeStaffFull(params, page, perPage)
  }
}
